import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import PopOut from './PopOut';
import Form from '../../modules/Form';

const Input = ({
  disabled,
  info,
  id,
  label,
  placeholder,
  value,
  isInvalid,
  invalidMessage,
  ...props
}) => {
  const inputRef = useRef();
  const inputDisabledMutationObserverRef = useRef();

  function onBlur(event) {
    Form.onInputBlur(event);
    if (props.onBlur) props.onBlur(event);
  }

  function onChange(event) {
    Form.onInputChange(event);
    if (props.onChange) props.onChange(event);
  }

  function onFocus(event) {
    Form.onInputFocus(event);
    if (props.onFocus) props.onFocus(event);
  }

  function onInput(event) {
    Form.onInputChange(event);
  }

  function onInvalid(event) {
    Form.onInputInvalid(event);
  }

  useEffect(() => {
    inputDisabledMutationObserverRef.current
      = Form.createInputDisabledMutationObserver(inputRef.current);

    return () => inputDisabledMutationObserverRef.current.disconnect();
  }, []);


  return (
    <div className="Form_control" data-form="control">
      <input
        className="Form_select"
        disabled={disabled}
        data-e2e="whats-on-search__radius__select"
        data-form="input"
        id={id}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onInput={onInput}
        onInvalid={onInvalid}
        placeholder={placeholder}
        ref={inputRef}
        type="text"
        value={value}
      />
      <label className="Form_controlLabel" htmlFor={id}>{label}</label>
      {info &&
        <PopOut info={info}>
          <button type="button" className="Form_popOutHit Form_popOutHit-right">i</button>
        </PopOut>
      }
      { isInvalid &&
        <p className="Form_validation" >{invalidMessage}</p>
      }
    </div>
  );
};

Input.defaultProps = {
  disabled: false,
  placeholder: '',
  value: '',
};

Input.propTypes = {
  disabled: PropTypes.bool,
  info: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isInvalid: PropTypes.bool,
  invalidMessage: PropTypes.string,
};

export default Input;
